<template>
  <header>
    <h1>
      Official USPS<sup>®</sup> Change-of-Address
    </h1>
  </header>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style scoped>
header {
  margin: 0 0 0 20px;
}
h1 {
  font-family: "HelveticaNeueW02-75Bold", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bold;
}
</style>
